"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePolicyLinks = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _api = require("../api");
var _useConfig = _interopRequireDefault(require("./useConfig"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(() => (0, _core.createStyles)({
  primaryLink: {
    color: '#000',
    textDecoration: 'underline'
  }
}));
const usePolicyLinks = function () {
  let {
    variant = 'default'
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const classes = useStyles();
  const {
    brandId
  } = (0, _useConfig.default)();
  const initialState = {
    terms_link: '',
    cookie_policy_link: '',
    privacy_link: ''
  };
  const [links, setLinks] = (0, _react.useState)(initialState);
  const fetchLinks = async () => {
    const [error, response] = await (0, _api.fetchLinks)(brandId);
    if (error) {
      setLinks(initialState);
      return;
    }
    setLinks(response);
  };
  (0, _react.useEffect)(() => {
    fetchLinks();
  }, []);
  return {
    terms: function () {
      for (var _len = arguments.length, chunks = new Array(_len), _key = 0; _key < _len; _key++) {
        chunks[_key] = arguments[_key];
      }
      return /*#__PURE__*/_react.default.createElement("a", {
        className: variant === 'primary' ? classes.primaryLink : '',
        target: "_blank",
        href: links.terms_link,
        rel: "noopener noreferrer"
      }, chunks);
    },
    cookie: function () {
      for (var _len2 = arguments.length, chunks = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        chunks[_key2] = arguments[_key2];
      }
      return /*#__PURE__*/_react.default.createElement("a", {
        className: variant === 'primary' ? classes.primaryLink : '',
        target: "_blank",
        href: links.cookie_policy_link,
        rel: "noopener noreferrer"
      }, chunks);
    },
    privacy: function () {
      for (var _len3 = arguments.length, chunks = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        chunks[_key3] = arguments[_key3];
      }
      return /*#__PURE__*/_react.default.createElement("a", {
        className: variant === 'primary' ? classes.primaryLink : '',
        target: "_blank",
        href: links.privacy_link,
        rel: "noopener noreferrer"
      }, chunks);
    }
  };
};
exports.usePolicyLinks = usePolicyLinks;